import request from '@/utils/request'
import qs from 'qs'

export function get(filters, options) {
  return request({
    url: '/api/indicatrix/get',
    method: 'get',
    params: {...filters, ...options}
  })
}
export function mushData({projectIds, viewId}, options) {
  return request({
    url: '/api/indicatrix/mushData',
    method: 'post',
    params: options,
    data: {projectIds, viewId},
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function save(indicatrixs) {
  return request({
    url: '/api/indicatrix/save',
    method: 'post',
    data: indicatrixs
  })
}
export function deleteMany(ids) {
  return request({
    url: '/api/indicatrix/deleteMany',
    method: 'delete',
    data: ids
  })
}
/**
 * 
 * @param {string} topProjectId 
 * @param {{viewIdOnly:boolean}}} options 
 * @returns 
 */
export function schemaOf(topProjectId, options) {
  return request({
    url: '/api/indicatrix/schemaOf',
    method: 'get',
    params:{
      topProjectId,
      ...options
    }
  })
}

export function getView(viewId) {
  return request({
    url: '/api/indicatrix/view?viewId='+viewId,
    method: 'get'
  })
}

export function getViews(viewIds) {
  return request({
    url: '/api/indicatrix/views',
    method: 'get',
    params:{viewIds:viewIds},
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}